module.exports = __webpack_public_path__ + "assets/favicon.9459cc1d.png";